import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ServiceCRUD } from '../../../../shared/crud/ServiceCRUD';
@Injectable()
export class AnalisePassagemBi03Service extends ServiceCRUD {
  private baseUrlService: string;
  url: string;

  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': sessionStorage.getItem('token')
    }),
  };

  constructor(public httpClient: HttpClient, router: Router) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
    this.url = `${this.baseUrlService}/analise_passagem_bi03`;
  }

  private setUrlDownload(chave, tipo: string): void {
    this.url = `${this.baseUrlService}/analise_passagem_bi03/download`
  }

  protected getURL(): string {
    return this.url;
  }

  public definirURLTotais() {
    this.url = 'passagens';
  }

  public getTotais(marcas: object): Promise<any> {
    this.definirURLTotais();
    return this.listar([], marcas);
  }

  public getDadosPrevisoes(filtro: object): Promise<any> {
    return this.listar([], filtro);
  }

  public downloadDoArquivo(chave, tipo: string, params: any): Observable<any> {
    this.setUrlDownload(chave, tipo);
    return this.downloadCSV([], params);
  }

  private setGetParameters(params: Object) {
    let getParams = new HttpParams();
    for (const key of Object.keys(params)) {
    getParams.append(key, params[key]);
    }
    return getParams;
    }

  getAllPaginate(
    ano: any,
    mes_inicial: any,
    mes_final: any,
    mercado?: any,
    grupo_economico?: any,
    regiao?: any,
    dealer?: any, filter?: any): Observable<any> {

    return this.httpClient.get<any>(`${this.baseUrlService + '/analise_passagem_bi03'}`, {
      headers: new HttpHeaders({
        'Authorization': sessionStorage.getItem('token')
      }),
      params: new HttpParams()
        .set('ano', ano.toString())
        .set('mes_inicial', mes_inicial.toString())
        .set('mes_final', mes_final.toString())
        .set('mercado', mercado.toString())
        .set('grupo_economico', grupo_economico.toString())
        .set('regiao', regiao.toString())
        .set('dealer', dealer.toString()),
    });
  }


  // getAllPaginate(params: any): Observable<any> {
  //   let httpParams = new HttpParams();
  //   Object.keys(params).forEach(function (key) {
  //     httpParams = httpParams.append(key, data[key]);
  //   });

  //   return this.httpClient.get<any>(`${this.baseUrlService + '/analise_passagem_bi03'}`, {
  //     headers: new HttpHeaders({
  //       'Authorization': sessionStorage.getItem('token')
  //     }),
  //     params: 
  //   });
  // }

  downloadCsvPassagens(
    data_inicial: any,
    data_final: any,
    part_number: any,
    dealer: any,
    regiao: any,
    grupo_economico: any,
    mercado: any,
    filter?: any): Observable<any> {

    return this.httpClient.get<any>(`${this.baseUrlService + '/analise_passagem_bi03/download'}`, {
      headers: new HttpHeaders({
        'Authorization': sessionStorage.getItem('token')
      }),
      responseType: "text" as 'json',
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('part_number', part_number ? part_number.toString() : "")
        .set('dealer', dealer.toString())
        .set('regiao', regiao.toString())
        .set('grupo_economico', grupo_economico.toString())
        .set('mercado', mercado.toString())
    }, );
  }

  downloadCsvPassagensDetalhado(
    data_inicial: any,
    data_final: any,
    part_number: any,
    dealer: any,
    regiao: any,
    grupo_economico: any,
    mercado: any,
    filter?: any): Observable<any> {

    return this.httpClient.get<any>(`${this.baseUrlService + '/analise_passagem_bi03/downloadDetalhado'}`, {
      headers: new HttpHeaders({
        'Authorization': sessionStorage.getItem('token')
      }),
      responseType: "text" as 'json',
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('part_number', part_number ? part_number.toString() : "")
        .set('dealer', dealer.toString())
        .set('regiao', regiao.toString())
        .set('grupo_economico', grupo_economico.toString())
        .set('mercado', mercado.toString())
    }, );
  }

  downloadCsvOneVoice(
    data_inicial: any,
    data_final: any,
    dealer: any,
    regiao: any,
    grupo_economico: any,
    mercado: any,
    filter?: any): Observable<any> {

    return this.httpClient.get<any>(`${this.baseUrlService + '/analise_passagem_bi03/relatorioOneVoice'}`, {
      headers: new HttpHeaders({
        'Authorization': sessionStorage.getItem('token')
      }),
      responseType: "text" as 'json',
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealer', dealer.toString())
        .set('regiao', regiao.toString())
        .set('grupo_economico', grupo_economico.toString())
        .set('mercado', mercado.toString())
    }, );
  }


  buscarFiltros(filtro: string): Observable<any> {

    return this.httpClient.get<any>(`${this.baseUrlService}/filtro/` + filtro, this.httpOptions);
  }

}
